import {
  EXPLAINER_CARD_HEADING,
  EXPLAINER_CARD_IMAGES,
  EXPLAINER_CARD_MESSAGES,
} from 'components/AiMode/constants';
import styles from './styles.module.scss';
import { Image } from 'packages/radiant-react/image';
import { IconID } from 'packages/radiant-react/icon';
import { Button } from 'packages/radiant-react/button';
import { Horizontal, Vertical } from 'packages/radiant-react/layout';
import { Colors, Typography } from 'packages/radiant-react/typography';

function ExplainerCard({ handleClose }: { handleClose: () => void }) {
  return (
    <Vertical className={styles['main-container']}>
      <Vertical className={styles['container']} hAlignContent="stretch" vAlignContent="center">
        <Horizontal className={styles['header-box']} vAlignContent="center">
          <Typography variant="h3" color={Colors.base}>
            {EXPLAINER_CARD_HEADING}
          </Typography>
          <Button icon={IconID.CROSS} type="tertiary" onClick={handleClose} />
        </Horizontal>
        <Horizontal className={styles['messages']}>
          <Typography variant="p" color={Colors.base}>
            {EXPLAINER_CARD_MESSAGES[0]}
          </Typography>
          <Typography variant="p-bold" color={Colors.base}>
            {EXPLAINER_CARD_MESSAGES[1]}
          </Typography>
          <Typography variant="p" color={Colors.base}>
            {EXPLAINER_CARD_MESSAGES[2]}
          </Typography>
        </Horizontal>
        <Horizontal className={styles['images-container']}>
          <Image src={EXPLAINER_CARD_IMAGES[0].src} alt={EXPLAINER_CARD_IMAGES[0].alt} />
          <Image src={EXPLAINER_CARD_IMAGES[1].src} alt={EXPLAINER_CARD_IMAGES[1].alt} />
        </Horizontal>
      </Vertical>
    </Vertical>
  );
}

export default ExplainerCard;
